export default {"src":"/_next/static/media/jll.28fdf054.svg","height":251,"width":581,"blurWidth":0,"blurHeight":0};